import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from 'app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { HelpMenuComponent } from './help-menu.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [HelpMenuComponent],
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    SharedModule,
    RouterModule,
    MatDialogModule,
    MatTooltipModule,
  ],
  exports: [HelpMenuComponent],
})
export class HelpMenuModule {}
